type ButtonProps = {
    size?: string | null;
    severity?: string | null;
    label?: string | null;
    icon?: string | null;
    iconPos?: string;
    text?: boolean;
    outlined?: boolean;
};

type ButtonContext = {
    disabled?: boolean;
};

export const buttonBaseClasses =
    'inline-flex items-center justify-center gap-2 font-deskly font-semibold text-button rounded-full select-none transition-colors duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus:outline-none';

export const buttonVariantClasses = {
    primary:
        'bg-primary text-primary-inverse hover:bg-primary-hover-contained-button active:bg-primary-pressed-contained-button',
    secondary:
        'border border-primary text-primary hover:border-transparent hover:bg-primary-hover-outlined-button active:bg-primary-pressed-outlined-button',
    tertiary: 'text-tertiary hover:text-tertiary-hover active:text-tertiary-pressed',
    textlink: 'text-tertiary hover:text-tertiary-hover active:text-tertiary-pressed',
    'primary-danger':
        'bg-primary-danger text-white hover:bg-primary-danger-hover active:bg-primary-danger-pressed',
    'tertiary-danger':
        'text-primary-danger hover:text-primary-danger-hover active:text-primary-danger-pressed',
    'textlink-danger':
        'text-primary-danger hover:text-primary-danger-hover active:text-primary-danger-pressed',
};

function resolveVariantClasses(props: ButtonProps): string {
    const isText = props.text || props.outlined;
    if (props.severity === 'danger') {
        return isText
            ? buttonVariantClasses['tertiary-danger']
            : buttonVariantClasses['primary-danger'];
    }
    return isText ? buttonVariantClasses['secondary'] : buttonVariantClasses['primary'];
}

export function createButtonPt() {
    return {
        root: ({props, context}: {props: ButtonProps; context: ButtonContext}) => ({
            class: [
                buttonBaseClasses,
                {
                    'px-4 py-2': props.size === null || props.size === undefined,
                    'text-sm py-1.5 px-3': props.size === 'small',
                    'text-xl py-3 px-4': props.size === 'large',
                },
                {'w-10 px-0 py-2': props.label == null && props.icon != null},
                resolveVariantClasses(props),
                {'opacity-40 pointer-events-none cursor-default': context.disabled},
                'cursor-pointer overflow-hidden',
            ],
        }),
        label: ({props}: {props: ButtonProps}) => ({
            class: [{'flex-1': props.label !== null, 'invisible w-0': props.label == null}],
        }),
        icon: ({props}: {props: ButtonProps}) => ({
            class: [
                'mx-0',
                {
                    'mr-2': props.iconPos === 'left' && props.label != null,
                    'ml-2 order-1': props.iconPos === 'right' && props.label != null,
                    'mb-2': props.iconPos === 'top' && props.label != null,
                    'mt-2': props.iconPos === 'bottom' && props.label != null,
                },
            ],
        }),
        loadingicon: ({props}: {props: ButtonProps}) => ({
            class: [
                'h-4 w-4 mx-0 animate-spin',
                {
                    'mr-2': props.iconPos === 'left' && props.label != null,
                    'ml-2 order-1': props.iconPos === 'right' && props.label != null,
                },
            ],
        }),
    };
}
